import http from '@/utils/http';

/**
 * 分类管理
 */
export default {
  getList: {
    p: 'post,/manage/category/getlist',
    r: (data) => http({ url: '/manage/category/getlist', method: 'post', data })
  },
  add: {
    p: 'post,/manage/category/add',
    r: (data) => http({ url: '/manage/category/add', method: 'post', data })
  },
  update: {
    p: 'post,/manage/category/update',
    r: (data) => http({ url: '/manage/category/update', method: 'post', data })
  },
  del: {
    p: 'post,/manage/category/delete',
    r: (data) => http({ url: '/manage/category/delete', method: 'post', data })
  },
  getOne: {
    p: 'post,/manage/category/getOne',
    r: (data) => http({ url: '/manage/category/getOne', method: 'post', data })
  }
};
